import { httpClient } from 'common/services';
import type { Call } from 'features/call/call-base/interfaces';
import type {
  SpawnCallRequest,
  SpawnedCallData,
} from 'features/spawn-call/interfaces';

async function spawnCall({
  sessionId,
  callId,
  terminationReason,
  userId,
}: SpawnCallRequest) {
  const route = `/call/${callId}/spawn-call`;
  const response = await httpClient.post<Call>(route, {
    sessionId,
    terminationType: terminationReason,
    userId,
  });
  return response.data;
}

async function sendSpawnedCallData({
  coreUserId,
  calleeNumber,
  callId,
  agentNumber,
}: SpawnedCallData) {
  const normalizedCalleeNumber = calleeNumber.replace(/^\+/, '');
  const route = `/call/spawn/${coreUserId}/${normalizedCalleeNumber}/${callId}/${encodeURIComponent(agentNumber)}`;
  const response = await httpClient.post<void>(route);
  return response.data;
}

export const SpawnCallDaoService = {
  spawnCall,
  sendSpawnedCallData,
};
